"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MainDeliveryMethodSwitch = void 0;
var _checkoutUi = require("@ori/checkout-ui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _addressFormContext = require("../../contexts/addressFormContext");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _PriceRange = require("../DeliveryOptions/PriceRange");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/** Used for flat delivery selection UI when both main delivery methods (home delivery & pickup point) can be used. */ const MainDeliveryMethodSwitch = (param)=>{
    let { isLoading, lastDeliveryItem, mainDeliveryMethod, setMainDeliveryMethod } = param;
    const { deliveryFee, deliveryMethod } = lastDeliveryItem !== null && lastDeliveryItem !== void 0 ? lastDeliveryItem : {};
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { setIsAddressFormOpen } = (0, _addressFormContext.useAddressForm)();
    const handleHomeDeliveryClick = (0, _react.useCallback)(()=>{
        setIsAddressFormOpen(false);
        setMainDeliveryMethod(_models.AddressItemDeliveryMethod.Home);
    }, [
        setIsAddressFormOpen,
        setMainDeliveryMethod
    ]);
    const handlePickupPointDeliveryClick = (0, _react.useCallback)(()=>{
        setIsAddressFormOpen(false);
        setMainDeliveryMethod(_models.AddressItemDeliveryMethod.PickupPoint);
    }, [
        setIsAddressFormOpen,
        setMainDeliveryMethod
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutUi.SelectableCard, {
                disabled: isLoading,
                selected: mainDeliveryMethod === _models.AddressItemDeliveryMethod.Home,
                onClick: handleHomeDeliveryClick,
                ...getTestIdProps(_models.TestId.HomeDeliveryMethodButton),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.MainDeliveryMethodContent, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: formatMessage('homeDelivery')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PriceRange.PriceRange, {
                            isBoldText: true,
                            isHomeDelivery: true,
                            lastDeliveryItemFee: deliveryFee,
                            lastDeliveryItemMethod: deliveryMethod
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutUi.SelectableCard, {
                disabled: isLoading,
                selected: mainDeliveryMethod === _models.AddressItemDeliveryMethod.PickupPoint,
                onClick: handlePickupPointDeliveryClick,
                ...getTestIdProps(_models.TestId.PickupDeliveryMethodButton),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.MainDeliveryMethodContent, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: formatMessage('pickupPoint')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PriceRange.PriceRange, {
                            isBoldText: true,
                            isHomeDelivery: false,
                            lastDeliveryItemFee: deliveryFee,
                            lastDeliveryItemMethod: deliveryMethod
                        })
                    ]
                })
            })
        ]
    });
};
exports.MainDeliveryMethodSwitch = MainDeliveryMethodSwitch;
